import { render, staticRenderFns } from "./VSubjectField.vue?vue&type=template&id=2439260a&"
import script from "./VSubjectField.vue?vue&type=script&lang=js&"
export * from "./VSubjectField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports